import { render, staticRenderFns } from "./manutd-98-99-home.vue?vue&type=template&id=5f224bea&"
import script from "./manutd-98-99-home.vue?vue&type=script&lang=js&"
export * from "./manutd-98-99-home.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports